import { useState, useContext } from "react";
import { IntlProvider } from "react-intl";
import intl from "./locale";
import { ThemeProvider } from "./core/providers/theme";
import { ConfigProvider, Spin } from "react_reusable_components";
import { BrowserRouter } from "react-router-dom";
import Routes from "./routes";
import { GlobalLoaderContext } from "./globalContext/globalLoader/globalLoaderProvider";
import OfflineNotification from "./components/OfflineNotification";

function UiComponentsProvider({ children, ...restProps }) {
  const { styleVariables } = restProps;

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: styleVariables?.primaryBg,
          colorTextBase: styleVariables?.textDefault,
          fontFamily: styleVariables?.fontFamilyRegular,
          fontSize: 16,
          fontWeight: 400,
          colorTextPlaceholder: styleVariables.grey3,
          colorIcon: styleVariables.iconColor,
          controlOutline: false,
          colorError: styleVariables?.error,
          borderRadius: 0,
          colorBorder: styleVariables.grey4,
        },
        components: {
          Typography: {
            colorText: styleVariables?.grey1,
            colorHeading: styleVariables?.textDefault,
            colorTextDescription: styleVariables?.textDefault,
            colorWarning: styleVariables?.error,
            colorLink: styleVariables?.textDefault,
            colorLinkActive: styleVariables?.textDefault,
            colorLinkHover: styleVariables?.textDefault,
            colorPrimaryHover: styleVariables?.textDefault,
            fontWeightStrong: styleVariables?.fontWeightBold,
          },
          Button: {
            colorPrimary: styleVariables?.primaryBg,
            colorTextDisabled: styleVariables.bodyBg,
            colorBgContainerDisabled: styleVariables.grey3,
          },
          Input: {
            colorPrimary: styleVariables?.grey4,
            colorPrimaryHover: styleVariables?.textDefault,
            colorPrimaryActive: styleVariables?.textDefault,
            colorBorder: styleVariables?.grey4,
            colorError: styleVariables?.grey4,
          },
          DatePicker: {
            colorPrimary: styleVariables?.grey4,
            colorPrimaryHover: styleVariables?.textDefault,
            colorPrimaryActive: styleVariables?.textDefault,
            colorBorder: styleVariables?.grey4,
            colorError: styleVariables?.grey4,
          },
          Pagination: {
            colorText: styleVariables?.textDefault,
            colorPrimary: styleVariables.primaryBg,
            colorPrimaryHover: styleVariables.primaryBg,
            colorTextActive: styleVariables.bodyBg,
            colorBorder: styleVariables?.grey4,
            colorBgContainer: styleVariables.bodyBg,
          },
          Select: {
            colorBgContainer: styleVariables.bodyBg,
            colorBorder: styleVariables?.grey4,
            colorIcon: styleVariables.textDefault,
            colorIconHover: styleVariables.textDefault,
            colorText: styleVariables.textDefault,
            colorPrimaryHover: styleVariables?.grey4,
            controlItemBgActive: styleVariables?.grey4,
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
}

function App() {
  const [locale] = useState("en");
  const [globalLoader] = useContext(GlobalLoaderContext);

  return (
    <ThemeProvider UiComponentsProvider={UiComponentsProvider} initial="base">
      <IntlProvider messages={intl[locale]} locale={locale} defaultLocale="en">
        <div className="app">
          <BrowserRouter>
            <OfflineNotification />
            <Routes />
            {(globalLoader?.loading || globalLoader?.sudoLoading) && (
              <Spin size={"large"} type={"fullscreen"} backgroundBlur={0.0} />
            )}
          </BrowserRouter>
        </div>
      </IntlProvider>
    </ThemeProvider>
  );
}

export default App;
